import { BeBand, BeBox, BePage, BeRow, BeSlider, BeStack, BeTextControl } from "@beos-css/react/index.ts";
import { useState } from "react";

export function BandDemo() {
	const [a, setA] = useState(1024);
	const [b, setB] = useState(1024);
	return (
		<section id="demo-page-band">
			<h2>Band (BeBand)</h2>
			<p>
				A slider cannot be aligned by its box: the bar moves with its optional label and limit rows, so there are four positions and no
				shared text line for <code>align="baseline"</code> to use. A <code>BeBand</code> owns three block tracks and the slider hands its
				parts to them, so the field meets the <em>bar</em>. Both rows below carry limit labels — the case that measured 17px out.
			</p>
			<BePage className="be-panel" pad={1}>
				<BeStack gap="section">
					<BeBox label="BeBand — the field meets the bar">
						<BeBand row>
							<BeSlider
								band
								thumbStyle="triangle"
								value={a}
								onChange={setA}
								min={64}
								max={4096}
								showLabel
								label="Screen font cache size"
								trailing={`${a} kB`}
								minLabel="64 kB"
								maxLabel="4096 kB"
							/>
							<BeTextControl label="Size" defaultValue="1024" />
						</BeBand>
					</BeBox>
					<BeBox label="BeRow — box alignment, 17px out">
						{/* Not `wrap`: flex breaks lines before shrinking, which would pre-empt the grower. */}
						<BeRow gap="item">
							<BeSlider
								thumbStyle="triangle"
								value={b}
								onChange={setB}
								min={64}
								max={4096}
								showLabel
								label="Screen font cache size"
								trailing={`${b} kB`}
								minLabel="64 kB"
								maxLabel="4096 kB"
							/>
							<BeTextControl grow label="Size" defaultValue="1024" />
						</BeRow>
					</BeBox>
				</BeStack>
			</BePage>
		</section>
	);
}
